import React from 'react'
import { NextPage } from 'next'
import PublicLayout from 'src/components/Layout/public'
import { Section } from 'src/components/Common/Section'
import { colors } from 'src/theme/colors'
import { Title } from 'src/components/Common'
import { NewsContainer, NewsWrapper } from 'src/components/News/todas/styles'
import TitleWrapper from 'src/components/Common/TitleWrapper'
import {INews} from 'src/service/api/api.types'
import { apiPublic } from 'src/service/api/api.public'
import Container from 'src/components/Common/Container'
import { GridSkeleton } from 'src/components/Skeleton/grid'
import { GridWrapper } from 'src/components/Grid/styles'
import { Card } from 'src/components/Common/Card'
import { Button } from 'src/components/Common/Button'
import { FaArrowCircleLeft } from 'react-icons/fa'
import {useTranslation} from "react-i18next";
import {BiNews} from "react-icons/bi";

const TotalNews: NextPage = () => {
  const { t } = useTranslation()
  const [news, setNews] = React.useState<INews[]>([])
  const [isLoading, setIsLoading] = React.useState(false)

  React.useEffect(() => {
    ;(async () => {
      await fetchNews()
    })()
  }, [])

  async function fetchNews() {
    setIsLoading(true)
    const res = await apiPublic.getNewsRecent(9999)
    if (res.kind === 'ok') {
      setNews(res.data)
    }
    setIsLoading(false)
  }

  function RenderLessons() {
    if (news && news?.length > 0) {
      return (
        <GridWrapper>
          {news.map(item => (
            <div key={`${item.id}`} className="card-grid">
              <Card
                imageWidth={276}
                imageHeight={147}
                data={item}
                preset="secondary"
                linkType="news"
              />
            </div>
          ))}
        </GridWrapper>
      )
    }

    return <></>
  }

  return (
    <PublicLayout showCategory={false}>
      <NewsContainer>
        <TitleWrapper>
          <Title
            borderMargin="medium"
            size="lg"
            borderColor={colors.palette.white}
            tx={t('news.title')}
            Icon={<BiNews />}
            hasIcon
            hasBorder={false}
            theme="light"
          />
        </TitleWrapper>
        <Section preset="courses" padding="1rem 0" paddingMobile="1rem 0">
          <Container>
            {isLoading ? (
              <GridSkeleton />
            ) : (
              <NewsWrapper>
                <div className="filters">
                  <Button
                    type="button"
                    isLink
                    href="/"
                    labelTx="news.buttonBack"
                    preset="secondary"
                    LeftAccessory={<FaArrowCircleLeft />}
                  />
                </div>
                <RenderLessons />

              </NewsWrapper>
            )}
          </Container>
        </Section>
      </NewsContainer>
    </PublicLayout>
  )
}

export default TotalNews
